import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  TableRow,
  Checkbox,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  AccordionDetails,
  Accordion,
  AccordionSummary,
  FormControlLabel,
  Tooltip,
} from '@material-ui/core';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import RefreshOutlined from '@material-ui/icons/RefreshOutlined';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import './configuration.less';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { apiRequest, apiBatchRequest, apiPost } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import './configuration.less';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
// import ConfigureWidgetData from "../common/Widgets/configureWidget";
import { th } from 'date-fns/locale';
import { GetSectionPermission, IsSectionVisible } from '../../utils/helper';
import Widget from '../common/Widgets/Widget';
import { SECTIONS } from "../../constants/appConstants";
export default class ConfigureWidgets extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      widgetConfig: [],
      isInEditView: false,
      addNewWidget: false,
      selectedWidgetConfig: {},
    };
  }

  componentWillMount() { }

  componentDidMount() {
    this.GetWidgetMasterList();
  }

  GetWidgetMasterList = () => {
    const { selectedGroup } = this.state;

    apiRequest({
      url:
        API_URL.Dashboard.GetWidgetMasterListByGroup +
        '?groupId=' +
        selectedGroup,
    }).then(({ data: response }) => {
      this.setState({
        widgetConfig: response || [],
        isInEditView: false,
        addNewWidget: false,
        selectedWidgetConfig: {},
      });
    });
  };

  renderBody = (IsEditable) => {
    if (this.state.isInEditView) {
      return this.getWidgetEditView();
    }
    return this.getMainListView(IsEditable);
  };

  getMainListView = (IsEditable) => {
    const { widgetConfig, performanceReports, selectedDatacenter } = this.state;
    return (
      <TableBody>
        <TableRow>
          <TableCell
            key={'configurechildHeader'}
            className="content-header sub-section row co-xs-12"
          >
            <div className="content-header row col-xs-12">
              Widgets
              <div className="end-xs col-xs">
                {IsEditable && IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_WIDGET, SECTIONS.ADD_EDIT) && (
                  <Tooltip title="Add New Widget">
                    <IconButton
                      className="white-button"
                      aria-label={'newWidget'}
                      size="small"
                      onClick={() => {
                        this.setState({
                          isInEditView: true,
                          addNewWidget: true,
                          selectedWidgetConfig: {},
                        });
                      }}
                    >
                      <AddCircleOutline fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            </div>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell key={'configuerHeadercell2'}>
            <div className="col-xs-12">
              <TableContainer>
                <Table
                  aria-labelledby="tableTitle"
                  size={'small'}
                  aria-label="enhanced table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell key={'WidgetName'}> Widget Name </TableCell>
                      <TableCell key={'WidgetType'}> Type </TableCell>
                      <TableCell key={'IsConfigurable'}>
                        {' '}
                        Is Configurable{' '}
                      </TableCell>
                      <TableCell key={'DataSource'}> DataSource </TableCell>
                      {IsEditable && (
                        <TableCell key={'Action'}> Action </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {widgetConfig.map((row, index) => {
                      return (
                        <TableRow key={row.name}>
                          <TableCell key={'WidgetName' + index}>
                            {' '}
                            {row.name}{' '}
                          </TableCell>
                          <TableCell key={'WidgetType' + index}>
                            {' '}
                            {row.widgetTypeName}{' '}
                          </TableCell>
                          <TableCell key={'WidgetAccessible' + index}>
                            <Checkbox
                              id={'isConfigurable' + index}
                              color="primary"
                              disabled={true}
                              defaultValue={row.isConfigurable}
                              checked={row.isConfigurable}
                              onChange={(event) => {
                                event.target.checked
                                this.handelChange(
                                  event.target.checked,
                                  'isAccessible',
                                  index
                                );
                              }}
                            />{' '}
                          </TableCell>
                          <TableCell key={'WidgetDefault' + index}>
                            {row.dataUrl}
                          </TableCell>
                          {IsEditable && (
                            <TableCell
                              key={'TCAction' + index}
                              onClick={() => {
                                if (row.widgetType != 10 && IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_WIDGET, SECTIONS.ADD_EDIT)) {
                                  this.setState({
                                    isInEditView: true,
                                    addNewWidget: false,
                                    selectedWidgetConfig: row,
                                  });
                                }
                              }}
                            >
                              {row.widgetType != 10 && IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_WIDGET, SECTIONS.ADD_EDIT) && (
                                <Tooltip title="Edit Widget">
                                  <IconButton aria-label="Edit">
                                    <EditIcon />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </TableCell>
        </TableRow>
      </TableBody>
    );
  };

  getWidgetEditView = () => {
    const { isInEditView, addNewWidget, selectedWidgetConfig } = this.state;
    if (isInEditView) {
      return (
        <Widget
          addNew={addNewWidget}
          chartConfig={addNewWidget === true ? {} : selectedWidgetConfig}
          masterConfig={addNewWidget === true ? {} : selectedWidgetConfig}
          configureMaster={true}
          onSaveConfiguration={this.onSaveConfiguration}
        ></Widget>
      );
    } else {
      return <></>;
    }
  };

  onSaveConfiguration = (configuration) => {
    const { addNewWidget } = this.state;
    apiPost({
      url: API_URL.Dashboard.UpdateWidgetMaster,
      postBody: configuration,
    }).then(({ success: isExecuted }) => {
      if (isExecuted === true) {
        if (configuration.widgetId > 0) {
          ShowToast(
            commonLabels.widgetConfigurationUpdateSuccess.message,
            toastType.SUCCESS,
            5000,
            commonLabels.widgetConfigurationUpdateSuccess.code
          );
        } else {
          ShowToast(
            commonLabels.widgetConfigurationAddedSuccess.message,
            toastType.SUCCESS,
            5000,
            commonLabels.widgetConfigurationAddedSuccess.code
          );
        }
      } else if (configuration.widgetId > 0) {
        ShowToast(
          commonLabels.widgetConfigurationUpdateFail.message,
          toastType.ERROR,
          5000,
          commonLabels.widgetConfigurationUpdateFail.code
        );
      } else {
        ShowToast(
          commonLabels.widgetConfigurationAddFail.message,
          toastType.ERROR,
          5000,
          commonLabels.widgetConfigurationAddFail.code
        );
      }
      this.GetWidgetMasterList();
    });
  };

  render() {
    const { isInEditView } = this.state;
    // const permission = GetSectionPermission(
    // //   SECTIONS.CONFIGURATION,
    // //   SECTIONS.ADD_UPDATE_WIDGET
    // );
    //  const IsEditable = permission.accessTypeId > 1 ? true : false;
    const isEditable = true;
    // const ShowData = permission.showData;

    return (
      <>
        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell key={'configureHeader'} className="content-header">
                <div className="content-header">
                  {' '}
                  {isInEditView && (
                    <div
                      className="col-xs-1"
                      style={{ display: 'inline-block', float: 'left' }}
                    >
                      <IconButton
                        className="white-button"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          this.setState({
                            isInEditView: false,
                            selectedWidgetId: 0,
                          });
                          this.GetWidgetMasterList();
                        }}
                      >
                        <ArrowBackIcon
                          className="white-button"
                          style={{ fill: 'white !important' }}
                          fontSize="small"
                        ></ArrowBackIcon>
                      </IconButton>
                    </div>
                  )}{' '}
                  Master Widgets Configuration
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          {this.renderBody(isEditable)}
        </Table>
      </>
    );
  }
}
